import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 10,
  steps: [
    addColumns({
      table: 'messages',
      columns: [{ name: 'flow_id', type: 'string', isOptional: true }]
    })
  ]
}
